export default function() {
  return {
    get: function(obj, name) {
      if (name.startsWith("lst")) return [];
      return "";
    }
  };
}
